import { render, staticRenderFns } from "./specialBusiness.vue?vue&type=template&id=32161718&scoped=true"
import script from "./specialBusiness.vue?vue&type=script&lang=js"
export * from "./specialBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32161718",
  null
  
)

export default component.exports